import {
  Layout,
  Input,
  Select,
  message,
  Button,
  Radio,
  Checkbox,
  Row,
  Col,
  Popconfirm,
  Upload,
  Breadcrumb,
  Tooltip,
  Tabs,
  ConfigProvider,
  Table,
  Drawer,
  Image,
} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import OAMSider from '../oam-sider'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { recordExpression } from '@babel/types'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import exerciseStyles from './oam-task.module.less'
import './oam-task.css'
import MonacoEditor from 'react-monaco-editor'
import ReactMarkdown from 'react-markdown'
import { CloseCircleOutlined, ClearOutlined } from '@ant-design/icons'
import confirm from 'antd/lib/modal/confirm'
import * as constants from '../../../constants/constants'
import ExerciseCard from '../../exercise/exercise-card'
const { Option } = Select
const { TextArea } = Input
import SplitPane, { Pane } from 'react-split-pane'
import taskLearnStyles from '@/pages/task/task-learn.module.less'
import {
  ForwardOutlined,
  FileTextOutlined,
  UpOutlined,
  DownOutlined,
  LogoutOutlined,
  KeyOutlined,
  FormOutlined,
} from '@ant-design/icons'
import submitSuccessSvg from '@/static/image/task/submit-success.svg'
import submitFailedSvg from '@/static/image/task/submit-failed.svg'
import FullscreenOutlined from '@ant-design/icons/lib/icons/FullscreenOutlined'
import FullscreenExitOutlined from '@ant-design/icons/lib/icons/FullscreenExitOutlined'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import zhCN from 'antd/lib/locale/zh_CN'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import lodingGif from '@/static/image/task/loding.gif'
import LoginRegisterModal from '@/component/modal/login-register/login-register' // checkIsTeacher,
import  marked  from 'marked'
import TooltipModal from '@/component/modal/stop-task-modal/TooltipModal'
import ModalDrag from '@/pages/components/ModaDrag/ModalDrag'
// import SimpleMDEEditor from 'yt-simplemde-editor'
// import 'yt-simplemde-editor/dist/style.css'
import axios from 'axios'
import Qs from 'qs'

export interface Props {}
export interface Props2 {}

const TSplitPane:any = SplitPane

const editorOptions = {
  selectOnLineNumbers: true,
  fontSize: 14,
  minimap: { enabled: false },
  lineDecorationsWidth: 5,
  lineNumbersMinChars: 2,
  quickSuggestions: true,
  // scrollBeyondLastLine: false,  // 控制是否可以滚动到最后一行下面
  // scrollbar: {
  //     verticalScrollbarSize: 0,  // 垂直滚动条宽度
  //     horizontalScrollbarSize: 0,  // 水平滚动条宽度
  // },
  automaticLayout: true, // 拖拽分屏线时自适应宽度
}

const editorReadOnlyoptions = {
  readOnly: true,
  selectOnLineNumbers: true,
  fontSize: 14,
  minimap: { enabled: false },
  lineDecorationsWidth: 5,
  lineNumbersMinChars: 2,
  quickSuggestions: false,
  automaticLayout: true, // 拖拽分屏线时自适应宽度
}

const options = {
  spellChecker: false,
  forceSync: true,
  tabSize: 4,
  status: false,
  toolbar: [
    'bold',
    'italic',
    'heading',
    'quote',
    'code',
    'table',
    'horizontal-rule',
    'unordered-list',
    'ordered-list',
    'link',
    /*{
          name: 'editPreview',
          action: () => {
              setNoteEditMode(!noteEditMode);
          },
          className: 'fa fa-paper-plane',
          title: noteEditMode?'预览':"编辑",
        },*/
  ],
  insertTexts: {
    link: [' <a href="', '" target="_blank"> </a>'],
    table: [
      '',
      '\n\n| 列1 | 列2 | 列3 |\n| -------- | -------- | -------- |\n| 内容     | 内容      | 内容     |\n\n',
    ],
    code: ['\n```python\n```\n'],
  },
}

const { TabPane } = Tabs

export const OAMTaskPreview: React.FC<Props> = (props) => {
  let timer //  query_task_info 轮询
  // let animationTimer // 轮询
  const animationTimer = useRef<any>()
  const checkStatusTimer = useRef<any>()

  const [submitStatus, setSubmitStatus] = useState(false) //运行状态
  const [submitTime, setSubmitTime] = useState('') //运行时间

  const [task, setTask] = useState(null as any) //当前实训任务
  const [menuSelected, setMenuSelected] = useState(false)
  const [menu, setMenu] = useState(null as any) //项目大纲
  const [userCode, setUserCode] = useState(null as any) //
  const [running, setRunning] = useState(false) // 运行中状态
  const [testRunning, setTestRunning] = useState(false) // 测试运行中状态
  const [submitMode, setSubmitMode] = useState(0) // 提交方式 1-运行 2-提交
  const [currentStatus, setCurrentStatus] = useState(null as any)
  const [report, setReport] = useState(null as any) //项目的报告
  const [taskStatus, setTaskStatus] = useState(0)
  const specialTreatment = useRef(false)
  const taskId = useRef(location?.search?.split('=')[1]) //当前实训任务ID
  const [outputIsFullScreen, setOutputIsFullScreen] = useState(false) //记录运行结果区域是否处于全屏状态
  const [isAnimation, setIsAnimation] = useState(false) //项目大纲弹出框是否可见
  const [submitImages, setSubmitImages] = useState([]) //运行结果图
  const [userImage, setUserImage] = useState(null as any) //
  const [userImageJs, setUserImageJs] = useState(null as any) //
  const [variables, setVariables] = useState(null as any) //运行的输出变量列表
  const [tooltipopen, setTooltipopen] = useState(false)
  const [stoping, setStoping] = useState(false) // 运行中状态
  const [stopedByOtherVis, setStopedByOtherVis] = useState(false)
  const [stopedMsg, setStopedMsg] = useState('')
  const [isHtml, setIsHtml] = useState(false) //项目大纲弹出框是否可见
  const [outputHeight, setOutputHeight] = useState(300) //结果区域的高度
  const [currentActiveTabKey, setCurrentActiveTabKey] = useState('1') //1 练习 2实验 ，右侧面板

  const [outputs, setOutputs] = useState(null as any) //运行的输出结果
  const [verticalPane1Height, setVerticalPane1Height] = useState(
    document.body.clientHeight / 2
  ) //
  const [multipleRunModalVis, setMultipleRunModalVis] = useState(false)
  const [valueContentOpen, setValueContentOpen] = useState(true)

  const submitState = useRef(0)

  const openValueContent = () => {
    {
      valueContentOpen ? setValueContentOpen(false) : setValueContentOpen(true)
    }
  }

  const queryTaskCallback = (response) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      // 成功
      setTask(response.exercise_info)
      setUserCode(response.exercise_info.default_code)
      setRunning(false)
      setTestRunning(false)
      setTaskStatus(response.exercise_info.submission_info.submission_status)
      setIsAnimation(response.exercise_info.submission_info.is_animation)
      if (response.exercise_info.submission_info) {
        //如果结果则更新运行信息
        // checkSpecialTreatmentId(taskId.current)
        // console.log(specialTreatment.current)
        submitState.current =
          response.exercise_info.submission_info.submission_status
        if (submitState.current == 1) {
          checkStatusTimer.current = setInterval(() => {
            checkRunningStatus(
              response.exercise_info.submission_info.exercise_submit_id
            )
          }, 500)
          if (response.exercise_info.submission_info.submit_mode == 1) {
            setTestRunning(true)
          } else {
            setRunning(true)
          }
        } else {
          setRunning(false)
          setTestRunning(false)
          clearInterval(timer)
          clearInterval(animationTimer.current)
        }
        if (response.exercise_info.submission_info.is_html) {
          setUserImage(response.exercise_info.submission_info.submission_output)
          setUserImageJs(response.exercise_info.submission_info.js_script)
          setOutputs('')
          eval(response.exercise_info.submission_info.js_script)
        } else if (
          response.exercise_info.submission_info.submission_output &&
          response.exercise_info.submission_info.submission_output != '' &&
          response.exercise_info.submission_info.submission_output.indexOf(
            '+--'
          ) >= 0 &&
          response.exercise_info.submission_info.submission_output.lastIndexOf(
            '--+'
          ) >= 0
        ) {
          specialTreatment.current = true
          setUserImage('')
          setUserImageJs('')
          try {
            specialTreatmentfun(
              response.exercise_info.submission_info.submission_output
            )
          } catch (e) {
            console.error(e)
          }
        } else {
          specialTreatment.current = false
          setUserImage('')
          setUserImageJs('')
          setOutputs(response.exercise_info.submission_info.submission_output)
        }

        // if(specialTreatment.current&&(response.exercise_info.submission_info.submission_status==2||response.exercise_info.submission_info.submission_status==3))

        if (response.exercise_info.submission_info.submission_code != '')
          setUserCode(response.exercise_info.submission_info.submission_code)
        if (response.exercise_info.submission_info.submission_variables != '')
          setVariables(
            response.exercise_info.submission_info.submission_variables
          )
        if (response.exercise_info.submission_info.submission_time != '')
          setSubmitTime(response.exercise_info.submission_info.submission_time)
        if (response.exercise_info.submission_info.submission_image) {
          setSubmitImages(
            response.exercise_info.submission_info.submission_image
          )
          if (response.exercise_info.submission_info.is_animation) {
            clearInterval(animationTimer.current)
            let imgs = response.exercise_info.submission_info.submission_image
            let n = 0
            animationTimer.current = setInterval(function () {
              // console.log('转视频', n)

              let imgContain: any =
                document.getElementById('animation_img') &&
                document.getElementById('animation_img')
              if (imgContain) {
                imgContain.src = 'data:image/jpg;base64,' + imgs[n]
                n = n + 1
                if (n >= imgs.length) {
                  n = 0
                }
              }
            }, 100)
          }
        }

        if (2 == response.exercise_info.submission_info.submission_status) {
          setSubmitStatus(true)
          setCurrentStatus(true)
          setSubmitMode(2)
          clearInterval(checkStatusTimer.current)
        } else if (
          3 == response.exercise_info.submission_info.submission_status
        ) {
          // 11111111111111
          setSubmitStatus(true)
          setCurrentStatus(false)
          setSubmitMode(2)
          clearInterval(checkStatusTimer.current)
        } else {
          setSubmitMode(1)
          setVariables('')
        }
      } else {
        //如果没有运行结果，则清空运行信息
        setOutputs(null as any)
        setSubmitImages([] as any)
        setVariables(null as any)
        setSubmitMode(1)
        setVariables('')
      }
      // console.log(response.exercise_info);
      // setTheChapterId(chapterId)
      // history.replaceState(
      //   null,
      //   '',
      //   `task_learn?project/${projectId}/chapter/${chapterId}/task/${response.exercise_info.id}/`
      // )
    } /*else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=oam_task';
        } */ else {
      message.error(response.message)
    }
  }
  const getTaskStatus = (isTeacher) => {
    // console.log(isTeacher, isTeacher, isTeacher)
    const _headers = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
    const url = 'exercise/api/query_task_by_id/'
    let params = {
      exercise_id: taskId.current,
      sessionid: Cookies.get('sessionid'),
      mode:2
    }
    // if (isTeacher) {
    //   params['mode'] = 2
    // }
    const _data = Qs.stringify(params)
    return axios
      .post(constants.BACKEND_API_URL + url, _data, _headers)
      .then((res) => res.data)
  }
  // 查询任务详情
  const queryTaskInfo = (isTeacher) => {
    let params = {
      exercise_id: taskId.current,
      sessionid: Cookies.get('sessionid'),
      mode:2
    }
    // if (isTeacher) {
    //   params['mode'] = 2
    // }
    sendHttpPostRequest(
      'exercise/api/query_task_by_id/',
      params,
      queryTaskCallback
    )
  }
  useEffect(() => {
    sendHttpPostRequest(
      //获取院校身份信息
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        console.log('debug')
        if (response.is_ok == true) {
          if (response?.college_id !== 0) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            // queryProject()
            getTaskStatus(response.college_info.is_college_teacher == 1)
              // getTaskStatus()
              .then((res) => {
                console.log('getTaskStatus', res)
                message.destroy()
                if (res.code == -100) {
                  // 未登录
                  document.getElementById('show-login-modal')!.click()
                } else if (res.is_ok) {
                  setTask(res.exercise_info)
                  // setTaskStatus(
                  //   res.exercise_info.submission_info.submission_status
                  // )

                  setUserCode(res.exercise_info.default_code)
                  // if (res.exercise_info.submission_info.submission_code != '')
                  //   setUserCode(
                  //     res.exercise_info.submission_info.submission_code
                  //   )
                  // setTheChapterId(chapterId)
                  // history.replaceState(null, "", `task_learn?project/${projectId}/chapter/${chapterId}/task/${response.exercise_info.id}/`);
                  setRunning(false)
                  setTestRunning(false)
                  // submitState.current =
                  //   res.exercise_info.submission_info.submission_status
                  if (res.exercise_info.submission_info) {
                    // 习题正误结果显示
                    if (
                      1 == res.exercise_info.submission_info.submission_status
                    ) {
                      checkStatusTimer.current = setInterval(() => {
                        checkRunningStatus(
                          res.exercise_info.submission_info.exercise_submit_id
                        )
                      }, 500)
                    } else if (
                      2 == res.exercise_info.submission_info.submission_status
                    ) {
                      setSubmitStatus(true)
                      setCurrentStatus(true)
                      setSubmitMode(2)
                      clearInterval(checkStatusTimer.current)
                    } else if (
                      3 == res.exercise_info.submission_info.submission_status
                    ) {
                      setSubmitStatus(true)
                      setCurrentStatus(false)
                      setSubmitMode(2)
                      clearInterval(checkStatusTimer.current)
                    } else if (
                      4 == res.exercise_info.submission_info.submission_status
                    ) {
                      clearInterval(checkStatusTimer.current)
                    }
                  } else {
                    setSubmitMode(1)
                    setVariables('')
                  }
                  if (submitState.current == 1) {
                    // if (res.exercise_info.submission_info.submit_mode == 1) {
                    //   setTestRunning(true)
                    // } else {
                    //   setRunning(true)
                    // }
                    timer = setInterval(() => {
                      queryTaskInfo(
                        response.college_info.is_college_teacher == 1
                      )
                      // queryTaskInfo();
                    }, 5000)
                  } else {
                    setRunning(false)
                    clearInterval(timer)
                    clearInterval(checkStatusTimer.current)
                    queryTaskCallback(res)
                  }
                }
              })
          }
        }
      }
    )

    const queryTaskCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        setTask(response.exercise_info)
        setUserCode(response.exercise_info.default_code)
        setRunning(false)
        setTestRunning(false)
      }
    }

    function fullScreenChange() {
      let isFull = document.fullscreenElement
      if (!isFull) {
        setOutputIsFullScreen(false)
        console.log('退出全屏')
      } else {
        setOutputIsFullScreen(true)
        console.log('进入全屏')
      }
    }
    document.addEventListener('fullscreenchange', fullScreenChange)
  }, [])

  const editorDidMount = (editor, monaco) => {
  }

  const renderValue = (value: any, record: any) => {
    console.log(record.var)
    if (value.length > 35) {
      return (
        <div key={record.var}>
          <div
            style={{
              color: '#f2f2f2',
              marginLeft: 20,
              marginRight: 20,
              marginBottom: 10,
              paddingTop: 0,
              borderRadius: 5,
            }}
          >
            {valueContentOpen
              ? value.slice(0, 35).replaceAll('\n', '<br/>')
              : value.replaceAll('\n', '<br/>')}
          </div>
        </div>
      )
    } else
      return (
        <div key={record.var}>
          <div
            style={{
              color: '#f2f2f2',
              marginLeft: 20,
              marginRight: 20,
              marginBottom: 10,
              paddingTop: 0,
              borderRadius: 5,
            }}
          >
            {value.replaceAll('\n', '<br/>')}
          </div>
        </div>
      )
  }
  const variableColumns: any = [
    {
      title: '变量',
      dataIndex: 'var',
      key: 'var',
      align: 'left',
      width: 60,
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      ellipsis: true,
      align: 'left',
      width: 60,
    },

    {
      title: (
        <div>
          取值{' '}
          <Button
            onClick={openValueContent}
            className={taskLearnStyles.openBtn}
            style={{ float: 'right', marginLeft: 5, color: '#a5b4fc' }}
          >
            {valueContentOpen ? (
              <span>
                展开
                <DownOutlined style={{ marginLeft: 5 }} />
              </span>
            ) : (
              <span>
                收起
                <UpOutlined style={{ marginLeft: 5 }} />
              </span>
            )}
          </Button>
        </div>
      ),
      dataIndex: 'value',
      key: 'value',
      align: 'left',
      width: 100,
      render: renderValue,
    },
  ]

  const onStopTaskOk = () => {
    setStoping(true)
    let data = {
      source: 1, //1 我的   2 学生
      exercise_id: taskId.current,
    }
    sendHttpPostRequest(
      'exercise/api/running_exercise_interrupt',
      data,
      (res) => {
        if (res.code == 0) {
          setTimeout(() => {
            setStoping(false)
            message.success('停止成功~')
          }, 2000)
          clearInterval(timer)
          clearInterval(checkStatusTimer.current)
          clearInterval(animationTimer.current)
          setRunning(false)
          setTestRunning(false)

          // getCommitRecord()
        } else {
          setStoping(false)
          message.error(res.msg)
        }
      }
    )
    setTooltipopen(false)
  }
  const checkRunningStatus = (exercise_submit_id) => {
    let data = {
      exercise_submit_id,
    }
    sendHttpPostRequest('exercise/api/exercise_running_status', data, (res) => {
      if (res.code == 0) {
        if (res.data.status == 4) {
          setStopedByOtherVis(true)
          setStopedMsg(res.msg)
          clearInterval(checkStatusTimer.current)
        } else if (res.data.status != 1) {
          clearInterval(checkStatusTimer.current)
        }
      } else {
        clearInterval(checkStatusTimer.current)
        clearInterval(timer)
        setRunning(false)
        setTestRunning(false)
      }
    })
  }

  /**
   * 点击了运行、提交按钮
   * @param submitMode 1: 测试  2: 提交
   */
  const exerciseSubmitBtnClick = (_submitMode: number) => {

        _submitMode == 2 ? setRunning(true) : setTestRunning(true)

    sendHttpPostRequest(
      'exercise/api/oam_run_exercise',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        exercise_id: taskId.current,
        user_code: userCode,
      },
      runCodeCallback.bind(this, _submitMode)
    )
  }

  // 习题提交回调
  const runCodeCallback = (submitMode: number, response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
    } else if (response.code == 0) {
      // 成功
      setOutputHeight(300)
      setSubmitImages(response.data.images)
      setIsAnimation(response.data.is_animation)
      setCurrentStatus(response.data.status) //是否运行成功
      if (response.data.submission_status == 2) {
        // 同步请求
        setVariables(response.data.submission_variables)
        setCurrentStatus(true)


        if (response.data.is_html) {
          setOutputs('')
          setUserImage(response.data.output)
          setUserImageJs(response.data.js_script)
          eval(response.data.js_script)
        } else if (response.data.is_animation) {
          clearInterval(animationTimer.current)
          let imgs = response.data.submission_image
          let n = 0
          animationTimer.current = setInterval(function () {
            // console.log("2转",n);

            let imgContain: any =
              document.getElementById('animation_img') &&
              document.getElementById('animation_img')
            if (imgContain) {
              imgContain.src = 'data:image/jpg;base64,' + imgs[n]
              n = n + 1
              if (n >= imgs.length) {
                n = 0
              }
            }
          }, 100)
        } else {
          setOutputs(response.data.submission_output)
        }
        setIsHtml(response.data.is_html)

        submitMode == 2 ? setRunning(false) : setTestRunning(false)
      } else {
        if (response.data.need_sleep) {
          // 处理spark 异步请求
          let renderResult = false
          let _params = {
            exercise_id: taskId.current,
            sessionid: Cookies.get('sessionid'),
          }
          // if (checkIsTeacher()) {
          //   _params['mode'] = 2
          // }

          let increment = 0 // 增量，倒计时 = 0;
          // 定时查询执行结果
          let interval = setInterval(() => {
            increment += 1
            console.log(increment)
            sendHttpPostRequest(
              'exercise/api/query_task_by_id/',
              _params,
              (response: any) => {
                let submission_status =
                  response.exercise_info.submission_info.submission_status
                setTaskStatus(submission_status)
                // checkSpecialTreatmentId(taskId.current)
                if (submission_status !== 1) {
                  clearInterval(interval)
                  clearInterval(checkStatusTimer.current)
                  setRunning(false)
                  setTestRunning(false)
                }
                if (
                  response.exercise_info.submission_info.submission_status == 2
                ) {
                  renderResult = true
                  clearInterval(interval)
                  clearInterval(checkStatusTimer.current)
                  increment = 0

                  setVariables(
                    response.exercise_info.submission_info.submission_variables
                  )
                  setCurrentStatus(true)
                  setIsAnimation(
                    response.exercise_info.submission_info.is_animation
                  )
                  setSubmitImages(
                    response.exercise_info.submission_info.submission_image
                  )

                  if (response.exercise_info.submission_info.is_html) {
                    setOutputs('')
                    setUserImage(
                      response.exercise_info.submission_info.submission_output
                    )
                    setUserImageJs(
                      response.exercise_info.submission_info.js_script
                    )
                    eval(response.exercise_info.submission_info.js_script)
                  } else if (
                    response.exercise_info.submission_info.submission_output &&
                    response.exercise_info.submission_info.submission_output !=
                      '' &&
                    response.exercise_info.submission_info.submission_output.indexOf(
                      '+--'
                    ) >= 0 &&
                    response.exercise_info.submission_info.submission_output.lastIndexOf(
                      '--+'
                    ) >= 0
                  ) {
                    specialTreatment.current = true
                    if (
                      response.exercise_info.submission_info.submission_output
                    ) {
                      setUserImage('')
                      setUserImageJs('')
                      specialTreatmentfun(
                        response.exercise_info.submission_info.submission_output
                      )
                    }
                  } else {
                    specialTreatment.current = false
                    setOutputs(
                      response.exercise_info.submission_info.submission_output
                    )
                  }
                  setIsHtml(response.exercise_info.submission_info.is_html)

                  submitMode == 2 ? setRunning(false) : setTestRunning(false)

                  return
                } else if (
                  response.exercise_info.submission_info.submission_status == 3
                ) {

                  if (
                    response.exercise_info.submission_info.submission_output &&
                    response.exercise_info.submission_info.submission_output !=
                      '' &&
                    response.exercise_info.submission_info.submission_output.indexOf(
                      '+--'
                    ) >= 0 &&
                    response.exercise_info.submission_info.submission_output.lastIndexOf(
                      '--+'
                    ) >= 0
                  ) {
                    specialTreatment.current = true
                    setUserImage('')
                    setUserImageJs('')
                    specialTreatmentfun(
                      response.exercise_info.submission_info.submission_output
                    )
                  } else {
                    specialTreatment.current = false
                  }
                  renderResult = true
                  clearInterval(interval)
                  clearInterval(checkStatusTimer.current)

                  increment = 0

                  setOutputs(
                    response.exercise_info.submission_info.submission_output
                  )
                  setVariables(
                    response.exercise_info.submission_info.submission_variables
                  )
                  setCurrentStatus(false)
                  submitMode == 2 ? setRunning(false) : setTestRunning(false)

                  return
                  // }
                }
              }
            )
          }, 5000) // 定时器
        } else {
          // 其他情况
          console.log('其他情况')
          setOutputs(response.data.output)
          setVariables(response.data.variables)
          setCurrentStatus(false)
          submitMode == 2 ? setRunning(false) : setTestRunning(false)
        }
      }
    } else if (response.code == -501) {
      // 权限不足
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
    } else if (response.code == -1) {
      setCurrentStatus(false)
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
    } else {
      message.error(response.message)
      setCurrentStatus(false)
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
    }
  }

  const onVerticalPane1Change = (height: any) => {
    setVerticalPane1Height(height)
  }

  const checkTaskInRepot = (task_id) => {
    let taskIn = false
    report?.json?.map((chapter) => {
      chapter?.tasks?.map((item) => {
        if (item.exercise_id == taskId.current) {
          taskIn = true
        }
      })
    })
    return taskIn
  }

  const specialTreatmentfun = (responseOutPut) => {
    let tb_startInd = responseOutPut.indexOf('+--')
    let tb_endInd = responseOutPut.lastIndexOf('--+') + 3
    let pre_str = responseOutPut.substr(0, tb_startInd)
    let nex_str = responseOutPut.substr(tb_endInd)

    let prepare_marked = responseOutPut.slice(tb_startInd, tb_endInd)

    let tbarr = prepare_marked.split('|')
    tbarr.shift()
    tbarr.pop()
    let tbstr = tbarr.join('|')
    for (let i = 0; i < tbstr.length; i++) {
      if (
        (tbstr[i] === '+' && tbstr[i + 1] === '-' && tbstr[i + 2] === '-') ||
        (tbstr[i] === '+' && tbstr[i - 1] === '-' && tbstr[i - 2] === '-')
      ) {
        tbstr = tbstr.replace(tbstr[i], '|')
      }
    }
    let marktable = marked.parse(tbstr)
    setOutputs(pre_str + marktable + nex_str)
  }

  const outputShowFull = () => {
    let full = document.getElementById('running-ouput-wrapper')
    launchIntoFullscreen(full)
    setOutputIsFullScreen(true)
  }

  const outputDelFull = () => {
    let full = document.getElementById('running-ouput-wrapper')
    exitFullscreen()
    setOutputIsFullScreen(false)
  }

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } 
  }

  const launchIntoFullscreen = (element: any) => {
    if (element.requestFullscreen) {
      element.requestFullscreen()
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen()
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen()
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen()
    }
  }


  //用户编辑代码发生改变
  const onUserCodeChange = (newValue, e) => {
    setUserCode(newValue)
  }

  if (task?.type !== 6) {
    return (
      <Layout className="task-learn-page">
        <TSplitPane
          allowResize={true}
          split="vertical"
          defaultSize={'50%'}
          primary="second"
          maxSize={-300}
        >
          <div style={{ height: 'calc(100vh - 50px)' }}>
            <TSplitPane
              maxSize={-90}
              style={{ height: 'calc(100vh - 50px)' }}
              onChange={onVerticalPane1Change}
              allowResize={true}
              split="horizontal"
              defaultSize={'50%'}
              pane2Style={{ maxHeight: '100%' }}
            >
              <div
                className={taskLearnStyles.userCode}
                style={{ width: '100%' }}
              >
                <div style={{ height: 40, background: '#1e1b4b', zIndex: 20 }}>
                  <Row
                    wrap={false}
                    style={{ height: 40 }}
                    justify="start"
                    align="middle"
                    gutter={[0, 0]}
                  >
                    <Col flex="auto">
                      <Row
                        wrap={false}
                        style={{ height: 22 }}
                        justify="center"
                        align="middle"
                        gutter={[0, 0]}
                      >
                        <Col style={{ height: 22 }} flex="auto">
                          {' '}
                          <div
                            style={{
                              overflow: 'hidden',
                              height: 22,
                              textAlign: 'center',
                              fontWeight: 600,
                              color: '#f2f2f2',
                            }}
                          >
                            {task?.title}{' '}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                <MonacoEditor
                  width="100%"
                  language="python"
                  theme={'vs-dark'}
                  value={userCode}
                  options={editorOptions}
                  onChange={onUserCodeChange}
                />
              </div>

              <div
                className={taskLearnStyles.outputResultWrapper}
                id="running-ouput-wrapper"
                style={{ width: '100%' }}
              >
                <div className={taskLearnStyles.runningOutputHeader}>
                  <Row
                    align="middle"
                    style={{
                      margin: 0,
                      height: 40,
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    <Col span={12}>
                      <div style={{ color: '#f2f2f2', width: '100%' }}>
                        <span
                          style={{
                            float: 'left',
                            marginRight: 10,
                            marginLeft: 10,
                          }}
                        >
                          输出结果
                        </span>
                         <img
                          hidden={
                            running ||
                            currentStatus == false ||
                            taskStatus == 4
                          }
                          src={submitSuccessSvg}
                          alt=""
                          style={{ width: 20, height: 20 }}
                        />
                        <img
                          hidden={
                            running ||
                            currentStatus == true ||
                            taskStatus == 4
                          }
                          src={submitFailedSvg}
                          alt=""
                          style={{ width: 20, height: 20 }}
                        /> 
                      </div>
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                      <span>
                        {checkTaskInRepot(taskId.current) == true ? (
                          <Tooltip
                            placement="top"
                            title={'本任务结果同步到项目报告'}
                          >
                            <FileTextOutlined
                              style={{ fontSize: 20, marginRight: 10 }}
                            />
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </span>
                      <span>
                        {!outputIsFullScreen ? (
                          <FullscreenOutlined
                            style={{ marginRight: 10 }}
                            className={taskLearnStyles.reundoIcon}
                            onClick={outputShowFull}
                          />
                        ) : (
                          <FullscreenExitOutlined
                            style={{ marginRight: 10 }}
                            className={taskLearnStyles.reundoIcon}
                            onClick={outputDelFull}
                          />
                        )}
                      </span>
                    </Col>
                  </Row>
                </div>

                <Tabs hidden={!(!running && !testRunning)} type="card">
                  <TabPane
                    tab="运行结果"
                    key="outputs"
                    style={{
                      overflow: 'auto',
                      maxHeight: outputIsFullScreen
                        ? `calc(100vh - ${70}px)`
                        : `calc(100vh - ${verticalPane1Height + 120}px)`,
                    }}
                  >
                    {outputs && !specialTreatment.current && (
                      <ReactMarkdown
                        className={taskLearnStyles.outputRenderMarkdown}
                        remarkPlugins={[gfm, remarkMath]}
                        rehypePlugins={[
                          rehypeHighlight,
                          rehypeKatex,
                          rehypeRaw,
                        ]}
                      >
                        {outputs.replaceAll('\n', '<br/>')}
                      </ReactMarkdown>
                    )}

                    {outputs && specialTreatment.current && (
                      <div
                        className={taskLearnStyles.tbContainer}
                        style={{
                          color: '#f2f2f2',
                          marginLeft: 20,
                          marginRight: 20,
                          marginBottom: 10,
                          paddingTop: 0,
                          borderRadius: 5,
                          maxWidth:'100%'
                        }}
                       
                        dangerouslySetInnerHTML={{ __html: outputs }}
                      ></div>
                    )}

                    <div>
                      {' '}
                      {!isAnimation &&
                        submitImages?.map((iamgeBase64, ind) => {
                          return (
                            <div
                              style={{
                                backgroundColor: '#fff',
                                margin: 10,
                                textAlign: 'center',
                              }}
                              key={String(ind)}
                            >
                              <img
                                style={{ backgroundColor: '#fff' , maxWidth:'100%'}}
                                src={'data:image/jpg;base64,' + iamgeBase64}
                              ></img>
                            </div>
                          )
                        })}
                      {isAnimation && (
                        <img
                          id="animation_img"
                          style={{maxWidth:'100%'}}
                          src={
                            'data:image/jpg;base64,' + submitImages &&
                            submitImages[0]
                          }
                          alt=""
                        />
                      )}
                    </div>

                    <div
                      id="user-image"
                      className={taskLearnStyles.renderOutputWrapper}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        overflow: 'auto',
                        backgroundColor: '#fff',
                        maxWidth:"100%"
                      }}
                      dangerouslySetInnerHTML={{
                        __html: userImage?.replaceAll('\n', ''),
                      }}
                    />
                  </TabPane>

                  <TabPane
                    tab="变量信息"
                    key="variables"
                    style={{
                      overflow: 'auto',
                      maxHeight: outputIsFullScreen
                        ? `calc(100vh - ${70}px)`
                        : `calc(100vh - ${verticalPane1Height + 120}px)`,
                    }}
                  >
                    <div className={taskLearnStyles.variableTableWrapper}>
                      <ConfigProvider locale={zhCN}>
                        <Table
                          dataSource={variables}
                          columns={variableColumns}
                          rowKey={(record) => record.var}
                          pagination={false}
                        />
                      </ConfigProvider>
                    </div>
                  </TabPane>
                </Tabs>

                {!(!running && !testRunning) && (
                  <div
                    style={{
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%,-50%)',
                      textAlign: 'center',
                    }}
                  >
                    <img height={100} width={100} src={lodingGif}></img>
                  </div>
                )}
                {stoping && (
                  <div
                    style={{
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%,-50%)',
                      textAlign: 'center',
                    }}
                  >
                    <span
                      style={{ fontSize: '60px', color: '#9A3232' }}
                      className="iconfont icon-dengdai--copy"
                    ></span>
                    <div style={{ marginTop: '24px', color: '#fff' }}>
                      任务正在停止...
                    </div>
                  </div>
                )}
              </div>
            </TSplitPane>

            <div
              // className={taskLearnStyles.bottomActionDiv}
              style={{
                height: 50,
                background: '#1e1b4b',
                border: 0,
                position: 'absolute',
                bottom: 0,
                width: '100%',
              }}
            >
              <Row
                wrap={false}
                justify="start"
                align="middle"
                style={{ height: 50, width: '100%' }}
              >
                <Col span={8} style={{ textAlign: 'left', paddingLeft: 15 }}>
                  <ClearOutlined
                    className={taskLearnStyles.reundoIcon}
                    style={{ color: '#4f46e5' }}
                    onClick={() => {
                      setUserCode(task?.default_code)
                    }}
                  />
                </Col>

                <Col span={16} style={{ textAlign: 'right', paddingRight: 25 }}>
                    <Button
                      id="submit-exercise-btn"
                      onClick={exerciseSubmitBtnClick.bind(this, 2)}
                      size="small"
                      type="primary"
                      className={taskLearnStyles.submitBtn}
                      style={{ marginLeft: 20, backgroundColor: '#54b7bf' }}
                      disabled={running}
                    >
                      {' '}
                      提 交
                    </Button>
                </Col>
              </Row>
            </div>
            <TooltipModal
              tooltipopen={tooltipopen}
              setTooltipopen={setTooltipopen}
              mode={'user'}
              onOk={onStopTaskOk}
              content={<p>此任务正在运行中，确定要停止任务吗？</p>}
            />
            <ModalDrag
              theme={'dark'}
              modalTitle={'提示'}
              modalContent={
                <Row
                  style={{ height: '135px' }}
                  align={'middle'}
                  justify="center"
                >
                  <Col>{stopedMsg}</Col>
                </Row>
              }
              open={stopedByOtherVis}
              footer={
                <Button
                  onClick={() => {
                    clearInterval(checkStatusTimer.current)
                    setRunning(false)
                    setTestRunning(false)
                    setStopedByOtherVis(false)
                  }}
                  type={'primary'}
                >
                  确定
                </Button>
              }
              onCancel={() => setStopedByOtherVis(false)}
            />
          </div>

          <div
            className={taskLearnStyles.setting}
            style={{ position: 'relative' }}
          >
            <div
              style={{
                height: 40,
                position: 'absolute',
                width: 5,
                top: 0,
                left: -5,
                backgroundColor: '#1e1b4b',
                zIndex: 10,
              }}
            ></div>

            <div
              style={{ position: 'absolute', top: 12, right: 10, zIndex: 99 }}
            >
              <LogoutOutlined
                onClick={() => {
                  window.close()
                }}
                className={taskLearnStyles.iconbuttons}
              />
            </div>
            <Tabs
              activeKey={currentActiveTabKey}
              onChange={(activeKey: any) => {
                setCurrentActiveTabKey(activeKey)
              }}
              type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane
                style={{ color: '#f2f2f2', paddingBottom: 0 }}
                tab={
                  <div style={{ width: '50%', fontSize: 16, fontWeight: 400 }}>
                    {' '}
                    <FileTextOutlined /> 描述
                  </div>
                }
                key="1"
              >
                {task?.video && task?.video !== '' && (
                  <div style={{ background: '#000000' }}>
                    <video
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        height: 250,
                        width: '100%',
                      }}
                      preload="preload"
                      controls={true}
                      controlsList="nodownload"
                    >
                      <source src={task?.video} type={'video/mp4'} />
                      您的浏览器不支持 HTML5 video 标签。
                    </video>
                  </div>
                )}

                <div id="task_desp">
                  <ReactMarkdown
                    className={taskLearnStyles.reactmarkdown}
                    remarkPlugins={[gfm, remarkMath]}
                    rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                  >
                    {task?.steps}
                  </ReactMarkdown>
                </div>

                {task?.images && task?.images?.length > 0 && (
                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <ConfigProvider locale={zhCN}>
                      {task?.images?.map((image: any, imageInd: number) => {
                        return (
                          <Row
                            key={image.name}
                            wrap={false}
                            justify="center"
                            align="middle"
                            style={{ marginTop: 10, marginBottom: 10 }}
                          >
                            <Col
                              span={24}
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <div style= {{maxHeight:800}} className={taskLearnStyles.previewImageWrap}>
                                <Image
                                  style={{
                                    backgroundColor: '#f2f2f2',
                                    borderRadius: 3,
                                  }}
                                  preview={false}
                                  src={
                                    constants.BACKEND_URL +
                                    image.path +
                                    image.name
                                  }
                                />
                              </div>

                              <div style={{ marginTop: 5 }}>
                                图{imageInd + 1}
                              </div>
                            </Col>
                          </Row>
                        )
                      })}
                    </ConfigProvider>
                  </div>
                )}

                <div className={taskLearnStyles.taskSteps}>
                  <div
                    style={{
                      height: 36,
                      lineHeight: '36px',
                      paddingLeft: 20,
                      borderRadius: 21,
                      backgroundImage:
                        'linear-gradient(90deg,#4f46e5 0%,rgba(79, 70, 229, 0) 100%)',
                    }}
                  >
                    任务步骤
                  </div>
                  <ReactMarkdown
                    className={taskLearnStyles.reactmarkdownTaskSteps}
                    remarkPlugins={[gfm, remarkMath]}
                    rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                  >
                    {task?.task_steps}
                  </ReactMarkdown>
                </div>

                {task?.task_conclude && task?.task_conclude !== '' && (
                  <div id="task_conclude">
                    <ReactMarkdown
                      className={taskLearnStyles.reactmarkdown}
                      remarkPlugins={[gfm, remarkMath]}
                      rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                    >
                      {task?.task_conclude}
                    </ReactMarkdown>
                  </div>
                )}

                <div id="tab_desp_bottom" style={{ height: 50 }}></div>
              </TabPane>

              {task?.reference_answer && (
                <TabPane
                  style={{ color: '#f2f2f2', paddingBottom: 0, paddingTop: 0 }}
                  tab={
                    <div
                      style={{ width: '50%', fontSize: 16, fontWeight: 400 }}
                    >
                      {' '}
                      <KeyOutlined rotate={180} /> 答案
                    </div>
                  }
                  key="3"
                >
                  <div
                    className={taskLearnStyles.userCode}
                    style={{ height: 'calc(100vh - 90px)' }}
                  >
                    <MonacoEditor
                      width="100%"
                      language="python"
                      theme={'vs-dark'} // | "vs-dark" | "hc-black"
                      value={task?.reference_answer}
                      options={editorReadOnlyoptions}
                      onChange={onUserCodeChange}
                      editorDidMount={editorDidMount}
                    />
                  </div>
                </TabPane>
              )}
            </Tabs>
          </div>
        </TSplitPane>
        <LoginRegisterModal></LoginRegisterModal>
      </Layout>
    )
  } else {
    return (
      <Layout style={{ background: '#1e1b4b' }} className="task-learn-page">
        <div
          style={{
            width: '100%',
            height: 40,
            background: '#1e1b4b',
            zIndex: 20,
          }}
        >
          <Row
            wrap={false}
            style={{ height: 40 }}
            justify="start"
            align="middle"
            gutter={[0, 0]}
          >
            <Col style={{ paddingLeft: 15, height: 22 }} flex="100px"></Col>

            <Col flex="auto">
              <Row
                wrap={false}
                style={{ height: 22 }}
                justify="center"
                align="middle"
                gutter={[0, 0]}
              >
                <Col style={{ height: 22 }} flex="auto">
                  {' '}
                  <div
                    style={{
                      overflow: 'hidden',
                      height: 22,
                      textAlign: 'center',
                      fontWeight: 600,
                      color: '#f2f2f2',
                    }}
                  >
                    {task?.title}{' '}
                  </div>
                </Col>
              </Row>
            </Col>

            <Col
              style={{ textAlign: 'right', paddingRight: 15, height: 22 }}
              flex="110px"
            >
              <LogoutOutlined
                onClick={() => {
                }}
                className={taskLearnStyles.iconbuttons}
              />
            </Col>
          </Row>
        </div>

        <div
          className={taskLearnStyles.pureContentWrapper}
          style={{ height: 'calc(100vh - 40px)', overflow: 'auto' }}
        >
          <div
            style={{
              color: '#f2f2f2',
              padding: 20,
              paddingBottom: 50,
              maxWidth: 900,
              margin: 'auto',
            }}
          >
            {task?.video && task?.video !== '' && (
              <div style={{ background: '#000000' }}>
                <video
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    height: 400,
                    width: '100%',
                  }}
                  preload="preload"
                  controls={true}
                  controlsList="nodownload"
                >
                  <source src={task?.video} type={'video/mp4'} />
                  您的浏览器不支持 HTML5 video 标签。
                </video>
              </div>
            )}

            <div id="task_desp">
              <ReactMarkdown
                className={taskLearnStyles.reactmarkdown}
                remarkPlugins={[gfm, remarkMath]}
                rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
              >
                {task?.steps}
              </ReactMarkdown>
            </div>

            {task?.images && task?.images?.length > 0 && (
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <ConfigProvider locale={zhCN}>
                  {task?.images?.map((image: any, imageInd: number) => {
                    return (
                      <Row
                        key={image.name}
                        wrap={false}
                        justify="center"
                        align="middle"
                        style={{ marginTop: 10, marginBottom: 10 }}
                      >
                        <Col
                          span={24}
                          style={{
                            textAlign: 'center',
                          }}
                        >
                          <div style={{maxHeight:800}} className={taskLearnStyles.previewImageWrap}>
                            <Image
                              style={{
                                backgroundColor: '#f2f2f2',
                                borderRadius: 3,
                              }}
                              preview={false}
                              src={
                                constants.BACKEND_URL + image.path + image.name
                              }
                            />
                          </div>

                          <div style={{ marginTop: 5 }}>图{imageInd + 1}</div>
                        </Col>
                      </Row>
                    )
                  })}
                </ConfigProvider>
              </div>
            )}

            {task?.task_conclude && task?.task_conclude !== '' && (
              <div id="task_conclude">
                <ReactMarkdown
                  className={taskLearnStyles.reactmarkdown}
                  remarkPlugins={[gfm, remarkMath]}
                  rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                >
                  {task?.task_conclude}
                </ReactMarkdown>
              </div>
            )}

            <div id="tab_desp_bottom" style={{ height: 50 }}></div>
          </div>
        </div>

        <LoginRegisterModal></LoginRegisterModal>
      </Layout>
    )
  }
}

export default OAMTaskPreview
